import { localize } from 'helpers/translator'
import actionTypes from '../actions/actionTypes'
import lessonSources from 'helpers/enums/lessonSources'

const defaultState = {
	showLoading: false,
	animation: 'wheel',
	isTransparent: true,
	text: '',
}

const loadingReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.MY_LIBRARY_LAUNCH_NEW_LIVE_SESSION:
		case actionTypes.MY_LIBRARY_LAUNCH_LIVE_LESSON:
		case actionTypes.MY_LIBRARY_PREVIEW_LAUNCH_ALL_DEVICES:
		case actionTypes.MY_LIBRARY_SCHOOL_USER_ONBOARDING_OVERLAY_CONFIRM:
		case actionTypes.MY_LIBRARY_SCHOOL_TRIAL_ONBOARDING_OVERLAY_CONFIRM:
		case actionTypes.MY_LIBRARY_TIME_TO_CLIMB_SUCCESS:
		case actionTypes.MY_LIBRARY_LAUNCH_HOMEWORK:
		case actionTypes.MY_LIBRARY_PREVIEW_LAUNCH_STUDENT_PACED:
		case actionTypes.STORE_PREVIEW_LAUNCH_STUDENT_PACED:
		case actionTypes.PRIVATE_LIBRARY_PREVIEW_LAUNCH_STUDENT_PACED:
		case actionTypes.MY_LIBRARY_LAUNCH_NEW_HOMEWORK:
		case actionTypes.MY_LIBRARY_DUPLICATE_LESSON_CONFIRMED:
		case actionTypes.FETCH_SHARE_DATA:
		case actionTypes.STOREFRONT_SHARE:
		case actionTypes.MY_LIBRARY_SHARE_LESSON:
		case actionTypes.MY_LIBRARY_SHARE_FOLDER:
		case actionTypes.GAME_CANCEL_CONFIRMED:
		case actionTypes.MY_LIBRARY_ROUTE_UPDATE:
		case actionTypes.GAME_SAVE:
		case actionTypes.FLOCABULARY_VIDEO_SELECTED:
		case actionTypes.FLOCABULARY_VIDEO_PREVIEW_SELECTED:
		case actionTypes.FLOCABULARY_CATEGORY_FLOCABULARY_SELECTED:
		case actionTypes.FLOCABULARY_INITIALIZE_SESSION:
		case actionTypes.FLOCABULARY_EDIT_FLOCABULARY:
		case actionTypes.FLOCABULARY_APPLY_SEARCH_SELECTED:
		case actionTypes.MY_LIBRARY_CREATE_GOOGLE_DRIVE_LESSON:
		case actionTypes.MAIN_TOPBAR_CREATE_GOOGLE_DRIVE_LESSON:
		case actionTypes.GOOGLE_SLIDES_LMS_REFRESH_CONFIRMED:
		case actionTypes.QUICK_LAUNCH_RETRY_LAUNCH:
		case actionTypes.MY_LIBRARY_EXPORT_TO_LOCAL_DRIVE:
		case actionTypes.FLIPGRID_CREATION_TOOL_SAVE:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_SAVE:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_SAVE:
		case actionTypes.INTERACTIVE_VIDEO_SAVE:
		case actionTypes.VIDEO_SAVE:
		case actionTypes.VIDEO_STORE_LESSON_SELECTED:
		case actionTypes.VIDEO_MY_VIDEOS_LESSON_SELECTED:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_EMBED_IN_SLIDE:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_UNSAVED_TRIM_AND_SAVE:
		case actionTypes.ONBOARDING_GUIDE_SESSION_PREVIEW_CARD_SELECTED:
		case actionTypes.ACTIVITY_BANKS_ACTIVITY_SELECTED_STARTED:
			return {
				...state,
				showLoading: true,
			}
		case actionTypes.MY_LIBRARY_DUPLICATE_LESSON:
		case actionTypes.MY_LIBRARY_EDIT_LESSON_INIT:
			return {
				...state,
				showLoading: action.lessonData.sourceInfo.type !== lessonSources.GOOGLE_SLIDES,
			}
		case actionTypes.GOOGLE_SLIDES_CREATE_AUTHORIZE_SUCCESS:
			return {
				...state,
				showLoading: action.isInIframe,
			}
		case actionTypes.MY_LIBRARY_DOWNLOAD_AND_LAUNCH_STARTED:
			return {
				...state,
				showLoading: true,
				isTransparent: false,
			}
		case actionTypes.GOOGLE_SLIDES_CONVERT_TO_DRAW_IT:
			return {
				...state,
				showLoading: true,
				animation: 'dots',
				text: localize('googleSlides_loading_convertToDrawIt'),
			}
		case actionTypes.QUIZ_VALIDATION_SUCCESS:
		case actionTypes.POLL_VALIDATION_SUCCESS:
		case actionTypes.OEQ_VALIDATION_SUCCESS:
		case actionTypes.DRAW_IT_VALIDATION_SUCCESS:
		case actionTypes.MATCHING_PAIRS_CT_SAVE_ACTIVITY_VALIDATE_SUCCESS:
		case actionTypes.DESMOS_VALIDATION_SUCCESS:
			return {
				...state,
				showLoading: true,
				text: action.text,
			}
		case actionTypes.MY_LIBRARY_SESSION_FETCHED:
		case actionTypes.MY_LIBRARY_LIVE_SESSION_FAILED:
		case actionTypes.MY_LIBRARY_SCHOOL_FREE_TRIAL_USER_ONBOARDING_OVERLAY_CONFIRM_SUCCESS:
		case actionTypes.MY_LIBRARY_SCHOOL_TRIAL_ONBOARDING_OVERLAY_CONFIRM_SUCCESS:
		case actionTypes.MY_LIBRARY_SCHOOL_FREE_TRIAL_ONBOARDING_OVERLAY_FAILED:
		case actionTypes.MY_LIBRARY_SHARE_FOLDER_DATA_LOADED:
		case actionTypes.MY_LIBRARY_SHARE_FOLDER_DATA_FAILED:
		case actionTypes.MY_LIBRARY_HOMEWORK_FETCHED:
		case actionTypes.MY_LIBRARY_HOMEWORK_FAILED:
		case actionTypes.MY_LIBRARY_DUPLICATE_LESSON_FAILED:
		case actionTypes.MY_LIBRARY_EDIT_LESSON_FAILED:
		case actionTypes.SHARE_VIEW_DATA_LOADED:
		case actionTypes.SHARE_VIEW_DATA_FAILED:
		case actionTypes.MY_LIBRARY_LTI_SESSION_FAILED:
		case actionTypes.MY_LIBRARY_SESSION_LTI_CANVAS_SAVED:
		case actionTypes.MY_LIBRARY_EXTENSION_SESSION_FAILED:
		case actionTypes.MY_LIBRARY_EXTENSION_PREMIUM_FEATURE_UPGRADE:
		case actionTypes.MY_LIBRARY_LESSONS_FETCHED:
		case actionTypes.MY_LIBRARY_LESSONS_FAILED:
		case actionTypes.GAME_SAVE_FAILED:
		case actionTypes.FLOCABULARY_SAVE_ERROR:
		case actionTypes.FLOCABULARY_VIDEO_PREVIEW_DATA_FETCHED:
		case actionTypes.FLOCABULARY_GET_RESULTS_SUCCESS:
		case actionTypes.FLOCABULARY_GET_RESULTS_ERROR:
		case actionTypes.FLOCABULARY_VIDEO_PREVIEW_DATA_FETCHED_ERROR:
		case actionTypes.FLOCABULARY_VIDEO_FETCHED_ERROR:
		case actionTypes.FLOCABULARY_VIDEO_FETCHED:
		case actionTypes.GOOGLE_SLIDES_AUTHORIZE_USER_FAILED:
		case actionTypes.GOOGLE_SLIDES_AUTHORIZE_USER_SUCCESS:
		case actionTypes.MY_LIBRARY_CREATE_GOOGLE_DRIVE_LESSON_SUCCESS:
		case actionTypes.GOOGLE_SLIDES_CONVERT_TO_DRAW_IT_FAILED:
		case actionTypes.GOOGLE_SLIDES_ACTIVITY_SAVED:
		case actionTypes.POLL_SAVE_POLL_ERROR:
		case actionTypes.OEQ_SAVE_OEQ_ERROR:
		case actionTypes.QUIZ_SAVE_QUIZ_ERROR:
		case actionTypes.DRAW_IT_SAVE_DRAW_IT_ERROR:
		case actionTypes.MATCHING_PAIRS_CT_SAVE_ACTIVITY_ERROR:
		case actionTypes.DESMOS_SAVE_DESMOS_ERROR:
		case actionTypes.QUICK_LAUNCH_LAUNCH_LESSON_FAILED:
		case actionTypes.MY_LIBRARY_EXPORT_TO_LOCAL_DRIVE_FETCHED:
		case actionTypes.FLIPGRID_CREATION_TOOL_SAVE_SUCCESS:
		case actionTypes.FLIPGRID_CREATION_TOOL_SAVE_ERROR:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_SAVE_SUCCESS:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_SAVE_ERROR:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_SAVE_SUCCESS:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_SAVE_ERROR:
		case actionTypes.INTERACTIVE_VIDEO_FINALIZE_CREATION_TOOL:
		case actionTypes.INTERACTIVE_VIDEO_SAVE_FAILED:
		case actionTypes.VIDEO_SAVE_FAILED:
		case actionTypes.VIDEO_STORE_LESSON_COPIED_SUCCESS:
		case actionTypes.VIDEO_STORE_LESSON_COPIED_FAILED:
		case actionTypes.INTERACTIVE_VIDEO_PUBLISH_ERROR:
		case actionTypes.VIDEO_COPY_FAILED:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_EMBED_IN_SLIDE_SAVE_SUCCESS:
		case actionTypes.INTERACTIVE_VIDEO_CREATION_EMBED_IN_SLIDE_SAVE_FAILED:
		case actionTypes.USER_COOKIE_BLOCKED_FAILED:
		case actionTypes.MY_LIBRARY_CREATE_GOOGLE_DRIVE_LESSON_FAILED:
		case actionTypes.ONBOARDING_GUIDE_SESSION_PREVIEW_CARD_SUCCESS:
		case actionTypes.ONBOARDING_GUIDE_SESSION_PREVIEW_CARD_FAILED:
		case actionTypes.ACTIVITY_BANKS_ACTIVITY_UPDATED:
		case actionTypes.ACTIVITY_BANKS_CUSTOM_ACTIVITY_UPDATED:
		case actionTypes.ACTIVITY_BANKS_ACTIVITY_UPDATE_FAILED:
			return {
				...defaultState,
			}
		case actionTypes.OEQ_QUESTION_UPDATE_ERROR:
		case actionTypes.POLL_QUESTION_UPDATE_ERROR:
			return {
				...state,
				showLoading: false,
			}
		default:
			return state
	}
}

export default loadingReducer
